import { useMutation } from '@apollo/client/react';
import { useAtomValue } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import { useEffect } from 'react';

import {
  ChangeDeliveryMethodDocument,
  GetAppointmentForChangeDeliveryMethodDocument,
} from '~/graphql/generated/graphql';
import { changeDeliveryMethodState } from '~/state/partials/change_delivery_method_modal/atoms';

export const useChangeDeliveryMethod = () => {
  const resetChangeDeliveryMethodModal = useResetAtom(changeDeliveryMethodState);
  const { appointmentId } = useAtomValue(changeDeliveryMethodState);
  const [changeDeliveryMethod, { data, error, loading }] = useMutation(
    ChangeDeliveryMethodDocument,
    {
      refetchQueries: [
        { query: GetAppointmentForChangeDeliveryMethodDocument, variables: { id: appointmentId } },
      ],
    },
  );

  useEffect(() => {
    if (data?.changeDeliveryMethod?.appointment) {
      resetChangeDeliveryMethodModal();
    }
  }, [data, resetChangeDeliveryMethodModal]);

  return {
    changeDeliveryMethod,
    loading,
    error,
  };
};
